/**
 * 投诉人查询页 - 凭「联系方式 + 查询码」查看本人投诉的受理状态与结果，无需登录
 */
import React, { useEffect, useState } from 'react';

export default function ComplaintStatusStandalone() {
  const [contact, setContact] = useState('');
  const [queryCode, setQueryCode] = useState('');
  const [captchaId, setCaptchaId] = useState('');
  const [captchaImage, setCaptchaImage] = useState('');
  const [captchaCode, setCaptchaCode] = useState('');
  const [captchaLoading, setCaptchaLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [list, setList] = useState(null);
  const hasContact = String(contact || '').trim().length > 0;

  const loadCaptcha = async () => {
    setCaptchaLoading(true);
    try {
      const base = typeof window !== 'undefined' ? (window.__BASE_URL__ || '') : '';
      const res = await fetch(`${base}/api/pxcharts/public/complaint/query/captcha`, { method: 'GET' });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || '图形验证码加载失败');
      setCaptchaId(String(data?.captchaId || '').trim());
      setCaptchaImage(String(data?.image || '').trim());
    } catch (err) {
      setError(err?.message || '图形验证码加载失败');
      setCaptchaId('');
      setCaptchaImage('');
    } finally {
      setCaptchaLoading(false);
    }
  };

  useEffect(() => {
    loadCaptcha();
  }, []);

  const handleQuery = async (e) => {
    e.preventDefault();
    const c = contact.trim();
    const q = queryCode.trim();
    if (!q) {
      setError('请填写查询码');
      return;
    }
    setError('');
    setLoading(true);
    setList(null);
    try {
      const base = typeof window !== 'undefined' ? (window.__BASE_URL__ || '') : '';
      const res = await fetch(`${base}/api/pxcharts/public/complaint/query`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          contact: c,
          queryCode: q,
          captchaId: hasContact ? '' : captchaId,
          captchaCode: hasContact ? '' : captchaCode.trim().toUpperCase(),
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || '查询失败');
      setList(Array.isArray(data.list) ? data.list : []);
    } catch (err) {
      setError(err.message || '网络错误，请稍后重试');
      setList([]);
      if (!hasContact) loadCaptcha();
    } finally {
      setLoading(false);
    }
  };

  const backToQuery = () => {
    setList(null);
    setError('');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#fff7ec] via-[#fffaf3] to-white px-4 py-8">
      <div className="mx-auto w-full max-w-3xl rounded-2xl border border-[#f3dfbf] bg-white shadow-[0_12px_36px_rgba(141,88,19,0.1)]">
        <div className="rounded-t-2xl bg-gradient-to-r from-[#a5161b] via-[#c11f24] to-[#8f1217] px-6 py-6 text-white">
          <div className="text-xs tracking-[0.2em] text-[#ffdca8]">SUNNER SUPERVISION</div>
          <h1 className="mt-2 text-2xl font-semibold">投诉受理状态查询</h1>
          <p className="mt-2 text-sm text-[#ffe9ce]">
            输入查询码进行进度追踪。如提交时填写联系方式，可同步填写联系方式提升匹配精度。
          </p>
        </div>
        <div className="px-6 py-6">
        <div className="text-center mb-6">
          <p className="text-sm text-gray-500 mt-1">
            {list === null
              ? '如您留过联系方式，请填写联系方式 + 查询码；若未留联系方式，仅输入查询码即可。'
              : '以下为您的投诉记录'}
          </p>
        </div>

        {list === null ? (
          <form onSubmit={handleQuery} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">联系方式（选填）</label>
              <input
                type="text"
                value={contact}
                onChange={(e) => setContact(e.target.value)}
                placeholder="若提交时留了邮箱或手机号，请填写"
                className="w-full rounded-lg border border-[#e8d8bd] bg-white px-4 py-2.5 text-sm text-gray-800 focus:border-[#c11f24] focus:outline-none focus:ring-2 focus:ring-[#f7d7a6]"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">查询码</label>
              <input
                type="text"
                value={queryCode}
                onChange={(e) => setQueryCode(e.target.value)}
                placeholder="提交成功后获得的查询码"
                className="w-full rounded-lg border border-[#e8d8bd] bg-white px-4 py-2.5 font-mono text-sm text-gray-800 focus:border-[#c11f24] focus:outline-none focus:ring-2 focus:ring-[#f7d7a6]"
              />
            </div>
            <p className="text-xs text-gray-500">
              {hasContact
                ? '已填写联系方式：将按“联系方式 + 查询码”匹配投诉记录。'
                : '未填写联系方式：仅可查询未留联系方式的投诉记录。'}
            </p>
            {!hasContact && (
              <div className="rounded-lg border border-[#efe0c8] bg-[#fffaf2] p-3">
                <label className="block text-sm font-medium text-gray-700 mb-1">图形验证码（必填）</label>
                <div className="flex items-center gap-2 mb-2">
                  {captchaImage ? (
                    <img src={captchaImage} alt="图形验证码" className="h-10 w-[132px] rounded border border-slate-200 bg-white" />
                  ) : (
                    <div className="h-10 w-[132px] rounded border border-slate-200 bg-slate-50 text-xs text-slate-400 flex items-center justify-center">
                      {captchaLoading ? '加载中...' : '暂无验证码'}
                    </div>
                  )}
                  <button
                    type="button"
                    onClick={loadCaptcha}
                    className="cursor-pointer rounded border border-[#e8d8bd] bg-white px-3 py-2 text-xs text-[#5b2b16] hover:bg-[#fff7ec]"
                  >
                    刷新
                  </button>
                </div>
                <input
                  type="text"
                  value={captchaCode}
                  onChange={(e) => setCaptchaCode(e.target.value)}
                  placeholder="请输入图形验证码"
                  className="w-full rounded-lg border border-[#e8d8bd] bg-white px-4 py-2.5 font-mono uppercase text-sm text-gray-800 focus:border-[#c11f24] focus:outline-none focus:ring-2 focus:ring-[#f7d7a6]"
                />
              </div>
            )}
            {error && <p className="text-sm text-red-600">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full cursor-pointer rounded-lg bg-[#b91c1c] py-3 font-medium text-white transition-colors duration-200 hover:bg-[#991b1b] disabled:cursor-not-allowed disabled:opacity-50"
            >
              {loading ? '查询中...' : '查询'}
            </button>
          </form>
        ) : (
          <div>
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold text-gray-800">我的投诉</h2>
              <button
                type="button"
                onClick={backToQuery}
                className="cursor-pointer text-sm text-[#a5161b] hover:text-[#8f1217]"
                title="更换联系方式或查询码后重新查询"
              >
                重新查询
              </button>
            </div>
            {list.length === 0 ? (
              <p className="text-gray-500 py-8 text-center">未查到记录，请核对联系方式与查询码是否正确。</p>
            ) : (
              <>
                {/* 移动端：卡片列表 */}
                <div className="md:hidden space-y-3">
                  {list.map((item) => (
                    <div key={item.id} className="border border-gray-200 rounded-xl p-4 bg-gray-50/50">
                      <div className="font-medium text-gray-800 mb-2">{item.title}</div>
                      <div className="flex flex-wrap gap-2 text-xs text-gray-600 mb-2">
                        <span>{item.category}</span>
                        <span className="px-2 py-0.5 rounded bg-[#fbe8cc] text-[#7a4b1d]">{item.status}</span>
                      </div>
                      <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
                        <span className="text-gray-500">处理结果</span>
                        <span className="text-gray-700">{(item.processResult || item.closedNote) || '—'}</span>
                        <span className="text-gray-500">提交时间</span>
                        <span className="text-gray-700">{item.createdAt ? new Date(item.createdAt).toLocaleDateString('zh-CN') : '—'}</span>
                        <span className="text-gray-500">办结时间</span>
                        <span className="text-gray-700">{item.closedAt ? new Date(item.closedAt).toLocaleDateString('zh-CN') : '—'}</span>
                      </div>
                    </div>
                  ))}
                </div>
                {/* 桌面端：表格 */}
                <div className="hidden md:block overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-gray-200">
                        <th className="text-left py-2 font-medium text-gray-700">标题</th>
                        <th className="text-left py-2 font-medium text-gray-700">类别</th>
                        <th className="text-left py-2 font-medium text-gray-700">受理状态</th>
                        <th className="text-left py-2 font-medium text-gray-700">处理结果</th>
                        <th className="text-left py-2 font-medium text-gray-700">提交时间</th>
                        <th className="text-left py-2 font-medium text-gray-700">办结时间</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => (
                        <tr key={item.id} className="border-b border-gray-100">
                          <td className="py-3 pr-2 font-medium text-gray-800">{item.title}</td>
                          <td className="py-3 pr-2 text-gray-600">{item.category}</td>
                          <td className="py-3 pr-2">
                            <span className="px-2 py-0.5 rounded bg-[#fbe8cc] text-[#7a4b1d]">{item.status}</span>
                          </td>
                          <td className="py-3 pr-2 text-gray-600 max-w-xs">{(item.processResult || item.closedNote) || '—'}</td>
                          <td className="py-3 pr-2 text-gray-500">{item.createdAt ? new Date(item.createdAt).toLocaleDateString('zh-CN') : '—'}</td>
                          <td className="py-3 text-gray-500">{item.closedAt ? new Date(item.closedAt).toLocaleDateString('zh-CN') : '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        )}

        <p className="text-center text-sm text-gray-400 mt-6">
          <a href="/complaint" className="text-[#a5161b] hover:underline">返回投诉举报</a>
        </p>
      </div>
      </div>
    </div>
  );
}
